<ng-container *ngIf="label">
  <a *ngIf="trueLink" (click)="showEntityPanel()" class="entity-link">{{ label }}</a>
  <span *ngIf="!trueLink">
    {{ label }}
  </span>
</ng-container>